import axios from "axios";
import React from "react";

import { NEWSLETTER_EXCLUDED_PAGES } from "../utils/constants";
import { Newsletter } from "./Newsletter";
import { useSessionStorage } from "../hooks/useSessionStorage";
import { AppArticle } from "../utils/orm";

/* eslint-disable @typescript-eslint/no-unused-vars */
const EmailCapture = (props: AppArticle) => {
    const {
        slug,
        templateName,
    } = props;

    const [emailCaptureReady, setEmailCaptureReady] = React.useState(false);
    const [showNewsletter, setShowNewsletter] = React.useState(false);
    const [userCountry, setUserCountry] = useSessionStorage("carmen_country");
    const [userDMA, setUserDMA] = useSessionStorage("carmen_dma");
    const [userCity, setUserCity] = useSessionStorage("carmen_city");

    const shouldNewsletterShow = () => {
        switch (templateName) {
        case "companyLanding": {
            return true;
        }
        case "landing":
        case "listicle":
        case "article": {
            // check slugs
            if (NEWSLETTER_EXCLUDED_PAGES.some((x) => x === slug)) {
                return false;
            }
            break;
        }
        default: {
            break;
        }
        }
        return true;
    };

    React.useEffect(() => {
        if (!userCountry) {
            axios
                .get("https://carmen.themuse.com/me")
                .then((response) => {
                    if (response.data.country) {
                        setUserCountry(response.data.country);
                    }
                    if (response.data.dma) {
                        setUserDMA(response.data.dma);
                    }
                    if (response.data.city) {
                        setUserCity(response.data.city);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
        setShowNewsletter(shouldNewsletterShow());
        setEmailCaptureReady(true);
    }, [userCountry]);

    if (!emailCaptureReady) {
        return null;
    }

    if (showNewsletter) {
        return <Newsletter />;
    }

    return null;
};

export { EmailCapture };
